module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "approvedIcon",
    style: ('background-color: ' + _vm.color)
  }, [_c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../../../assets/check-icon.svg"),
      "alt": "check"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5502aaec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/ApprovedIcon.vue
// module id = 3191
// module chunks = 0